/**
 * Test environments use com-{siteName}={environmentName}.vercel.app, so a configured fully qualified
 * domain name should be returned to support navigation between apps.
 * Stage and production environments use a single domain and can navigate between each other with relative URLs
 * @returns string
 */
export const getSiteBaseUrl = (
  siteName: "PDP" | "Editorial" | "Search"
): string => {
  switch (siteName) {
    case "PDP":
      return getPdpBaseUrlVariable() ?? "/";
    case "Editorial":
      return getEditorialBaseUrlVariable() ?? "/";
    case "Search":
      return getSearchBaseUrlVariable() ?? "/";
    default:
      return "/";
  }
};

export const getPdpBaseUrlVariable = (): string | null => {
  const baseUrl = process.env.NEXT_PUBLIC_PDPHost as string;

  if (!baseUrl) {
    return null;
  }

  return formatBaseUrl(baseUrl);
};

export const getSearchBaseUrlVariable = (): string | null => {
  const baseUrl = process.env.NEXT_PUBLIC_SearchHost as string;

  if (!baseUrl) {
    return null;
  }

  return formatBaseUrl(baseUrl);
};

export const getEditorialBaseUrlVariable = (): string | null => {
  const baseUrl = process.env.NEXT_PUBLIC_EditorialHost as string;

  if (!baseUrl) {
    return null;
  }

  return formatBaseUrl(baseUrl);
};

/**
 * Everything that depends on getSiteBaseUrl does not include it's own
 * forward slash after the baseUrl, so ensure it's returned here
 * in the case that the variable in ADO is not a relative URL and does not
 * end with forward slash
 */
const formatBaseUrl = (baseUrl: string): string => {
  if (baseUrl !== "/" && !baseUrl.endsWith("/")) {
    return `${baseUrl}/`;
  }
  return baseUrl;
};
